/**
 * Constant values that are needed in more than one file and don't need state management through Context API or component
 */

export const validEmail: RegExp = /^[^\s@]+@[^\s@]+$/;
